import { render, staticRenderFns } from "./ClinicalGuideManager.vue?vue&type=template&id=5bab0f62&scoped=true&"
import script from "./ClinicalGuideManager.vue?vue&type=script&lang=js&"
export * from "./ClinicalGuideManager.vue?vue&type=script&lang=js&"
import style0 from "./ClinicalGuideManager.vue?vue&type=style&index=0&id=5bab0f62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bab0f62",
  null
  
)

export default component.exports